import { call, put, takeLatest } from "redux-saga/effects";
import { mapBackendMessage } from "../../screen/notification/BackendMessage";
import {
  adminEditFailure,
  adminEditSuccess,
  adminViewFailure,
  adminViewSuccess,
  changePasswordFailure,
  changePasswordSuccess,
  loginFailure,
  loginSuccess,
  refreshTokenFailure,
  refreshTokenSuccess,
  registerFailure,
  registerSuccess,
  requestMobileOtpFailure,
  requestMobileOtpSuccess,
  requestOtpFailure,
  requestOtpSuccess,
  updatePasswordFailure,
  updatePasswordSuccess,
  verifyMobileOtpFailure,
  verifyMobileOtpSuccess,
  verifyOtpFailure,
  verifyOtpSuccess,
} from "./AuthAction";

import CryptoJS from "crypto-js";
import {
  AdminEditEffect,
  AdminViewEffect,
  AuthEffect,
  ChangePasswordEffect,
  ForgotPasswordEffect,
  MobileOtpSendEffect,
  OtpSendEffect,
  RefreshTokenEffect,
  setAuthHeader,
  SignUpEffect,
  VerifyMobileOtpEffect,
  VerifyOtpEffect,
} from "./AuthEffect";
import {
  ADMIN_EDIT_REQUEST,
  ADMIN_VIEW_REQUEST,
  CHANGE_PASSWORD_REQUEST,
  LOGIN_REQUEST,
  MOBILE_OTP_REQUEST,
  REFRESH_TOKEN_REQUEST,
  REGISTER_REQUEST,
  REQUEST_OTP_REQUEST,
  UPDATE_PASSWORD_REQUEST,
  VERIFY_MOBILE_OTP_REQUEST,
  VERIFY_OTP_REQUEST,
} from "./AuthTypes";

const SECRET_KEY = "843567893696976453275974432697R634976";

//Login
function* loginSaga(action) {
  try {
    const response = yield call(AuthEffect, action.payload);

    const { accessToken, refreshToken, userData: user } = response.data;

    if (accessToken && refreshToken && user.email) {
      setAuthHeader(accessToken, user.email);

      if (accessToken && refreshToken && user.email) {
        setAuthHeader(accessToken, user.email);
        const encryptedAccessToken = CryptoJS.AES.encrypt(
          accessToken,
          SECRET_KEY
        ).toString();
        const encryptedRefreshToken = CryptoJS.AES.encrypt(
          refreshToken,
          SECRET_KEY
        ).toString();
        localStorage.setItem("accessToken", encryptedAccessToken);
        localStorage.setItem("refreshToken", encryptedRefreshToken);
        yield put(loginSuccess({ user }));
      } else {
        const errorMessage = response.data.body?.error || "Login failed";
        throw new Error(errorMessage);
      }
    }
  } catch (error) {
    const backendMessage = error.response?.data?.message;
    const mappedMessage = mapBackendMessage(backendMessage);
    yield put(loginFailure({ errormessage: mappedMessage }));
  }
}

//Register
function* signupSaga(action) {
  try {
    const response = yield call(SignUpEffect, action.payload);
    if (response?.status === 200) {
      yield put(registerSuccess({ ...response.data }));
    } else {
      const errorMessage = response.data.body?.error || "Registration failed";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to register user";
    yield put(registerFailure({ message, errorFields }));
  }
}

// Send OTP
function* sendOtpSaga(action) {
  try {
    const response = yield call(OtpSendEffect, action.payload);

    if (response?.status === 200) {
      yield put(requestOtpSuccess(response.data));
    } else {
      const errorMessage = response?.data?.message || "Otp failed to send";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      requestOtpFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

//Verify Otp
function* verifyOtpSaga(action) {
  try {
    const response = yield call(VerifyOtpEffect, action.payload);

    if (response?.status === 200) {
      yield put(verifyOtpSuccess(response.data));
    } else {
      const errorMessage = response?.data?.message || "Failed to verify OTP";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      verifyOtpFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

// Mobile Send OTP
function* mobileSendOtpSaga(action) {
  try {
    const response = yield call(MobileOtpSendEffect, action.payload);

    if (response?.status === 200) {
      yield put(requestMobileOtpSuccess(response.data));
    } else {
      const errorMessage =
        response?.data?.message || "Mobile Otp failed to send";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      requestMobileOtpFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

//Verify Mobile Otp
function* verifyMobileOtpSaga(action) {
  try {
    const response = yield call(VerifyMobileOtpEffect, action.payload);

    if (response?.status === 200) {
      yield put(verifyMobileOtpSuccess(response.data));
    } else {
      const errorMessage = response?.data?.message || "Failed to verify OTP";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      verifyMobileOtpFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

// Resend OTP
// function* resendOtpSaga(action) {
//   try {
//     const response = yield call(ResendOtpEffect, action.payload);
//     if (response.data.success) {
//       yield put(resendOtpSuccess(response.data));
//     } else {
//       throw new Error(response.data.message || "Failed to resend OTP");
//     }
//   } catch (error) {
//     yield put(
//       resendOtpFailure(error.response?.data?.message || "Resend OTP failed")
//     );
//   }
// }

// Update Password for forgot password
function* updatePasswordSaga(action) {
  try {
    const response = yield call(ForgotPasswordEffect, action.payload);
    if (response?.status === 200) {
      yield put(updatePasswordSuccess(response.data));
    } else {
      const errorMessage =
        response?.data?.message || "Failed to change password";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      updatePasswordFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

// Change Password
function* changePasswordSaga(action) {
  try {
    const response = yield call(ChangePasswordEffect, action.payload);
    if (response?.status === 200) {
      yield put(changePasswordSuccess(response.data));
    } else {
      const errorMessage =
        response?.data?.message || "Failed to update password";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      changePasswordFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

//Admin Edit
function* adminEditSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(AdminEditEffect, action.payload, config);

    if (response?.status === 200) {
      yield put(
        adminEditSuccess({
          updatedAdminData: response.data.user,
        })
      );
    } else {
      throw new Error(response?.data?.message || "Profile update failed");
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to edit profile";
    yield put(adminEditFailure({ errormessage: message, errorFields }));
  }
}

// Admin View
function* adminViewSaga(action) {
  try {
    const response = yield call(AdminViewEffect, action.payload);

    if (response?.status === 200) {
      yield put(adminViewSuccess(response.data));
    } else {
      const errorMessage = response?.data?.message || "Failed to view admin";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const backendMessage =
      error?.response?.data?.message || "An unexpected error occurred";
    const mappedMessage = mapBackendMessage(backendMessage);
    yield put(adminViewFailure({ errormessage: mappedMessage }));
  }
}

//Refresh token
function* refreshTokenSaga(action) {
  try {
    const response = yield call(RefreshTokenEffect, action.payload);

    if (response?.status === 200) {
      yield put(refreshTokenSuccess(response.data));
    } else {
      const errorMessage = response?.data?.message || "Failed to verify OTP";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      refreshTokenFailure({
        errorMessage: message,
        errorFields,
      })
    );
  }
}

export function* AuthSaga() {
  yield takeLatest(LOGIN_REQUEST, loginSaga);
  yield takeLatest(REGISTER_REQUEST, signupSaga);
  yield takeLatest(REQUEST_OTP_REQUEST, sendOtpSaga);
  yield takeLatest(VERIFY_OTP_REQUEST, verifyOtpSaga);
  yield takeLatest(MOBILE_OTP_REQUEST, mobileSendOtpSaga);
  yield takeLatest(VERIFY_MOBILE_OTP_REQUEST, verifyMobileOtpSaga);
  // yield takeLatest(RESEND_OTP_REQUEST, resendOtpSaga);
  yield takeLatest(UPDATE_PASSWORD_REQUEST, updatePasswordSaga);
  yield takeLatest(ADMIN_EDIT_REQUEST, adminEditSaga);
  yield takeLatest(ADMIN_VIEW_REQUEST, adminViewSaga);
  yield takeLatest(CHANGE_PASSWORD_REQUEST, changePasswordSaga);
  yield takeLatest(REFRESH_TOKEN_REQUEST, refreshTokenSaga);
}
